export enum loaderSource {
    addlead = 1,
    generateQuotation,
    submitPolicy,
    generateQuotationPDF,
    saveQuotation,
    addActivity,
    addNote,
    default
}
